import React from 'react';
import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

import { colors, FONT_FAMILY_DISPLAY } from '@theme';

interface SectionCardProps {
    title: string;
    children: ReactNode;
    action?: ReactNode;
    sx?: SxProps<Theme>;
    subtitle?: string;
    tail?: string;
    icon?: unknown;
}

const SectionCard: React.FC<SectionCardProps> = (props) => {
    const {
        title,
        children,
        action,
        sx,
        subtitle,
        tail
    } = props;

    return (
        <Box sx={{ mb: { xs: 3, md: 4 }, ...sx }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    gap: 1,
                    mb: 2,
                    flexWrap: 'wrap'
                }}
            >
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        component="h2"
                        sx={{
                            fontFamily: FONT_FAMILY_DISPLAY,
                            fontWeight: 600,
                            letterSpacing: '-0.02em',
                            fontSize: { xs: 22, md: 28 },
                            lineHeight: 1.15,
                            color: colors.blue
                        }}
                    >
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="caption" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {tail && (
                        <Typography
                            sx={{
                                color: 'text.secondary',
                                whiteSpace: 'nowrap',
                                fontWeight: 600
                            }}
                        >
                            {tail}
                        </Typography>
                    )}
                    {action}
                </Box>
            </Box>
            {children}
        </Box>
    );
};

export default SectionCard;
